export const PASSWORD_RULES_MESSAGE = (
  <>
    Password must be at least 8 characters long, contain an uppercase letter, a
    lowercase letter, a number, and a special character among{" "}
    <b>@ $ ! % * ? &</b>
  </>
)

export const CHAT_MESSAGE_ERROR_TEXT = "Ops! Something went wrong. Please try again."
